import { Module } from 'vuex'
import { CommonAppState } from '@bd/store-modules/types'
import { TransactionHistoryState } from '@bd/store-modules/types/transactionHistory'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

const transactionHistory: Module<TransactionHistoryState, CommonAppState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default transactionHistory
